import React, { useMemo } from "react";
import { Flex, Icon, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { useRouter } from "next/router";
import { usePostHog } from "posthog-js/react";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import { useQuery } from "react-query";
import { Divider } from "../..";
import { Question } from "../../common/Icons";
import { Stars } from "../Reviews/Stars";

const messages = defineMessages({
  buyer: "Verified buyer",
  questions: "vragen",
  noReviews: "Geen beoordelingen",
  noQuestions: "Geen",
});

interface ReviewOverviewProps {
  id: string;
}

export const ReviewsOverview: React.FC<ReviewOverviewProps> = ({ id }) => {
  const intl = useIntl();
  const router = useRouter();
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const productId = useMemo(() => id?.slice(id.lastIndexOf("/") + 1), [id]);
  const { data: score } = useQuery(
    ["productScore", productId],
    async () => {
      const {
        data: [score],
      } = await supabase.rpc("product_full_stats", {
        p_productid: productId,
      });
      return score;
    },
    { refetchOnWindowFocus: false }
  );
  const goToSection = (id) => {
    const route = { query: { ...router.query, page: 1, tab: id } };
    const el = document?.getElementById("reviews");

    router.push(route, undefined, { shallow: true });

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Flex fontSize={"16px"} mb={["16px", "22px"]}>
      <Flex
        as="a"
        href={`#questions`}
        fontWeight={score && score?.review_count ? 600 : 500}
        alignItems="center"
        onClick={(e) => {
          e.preventDefault();
          goToSection("reviews");
          // posthog.capture("Clicked Product Reviews");
        }}
      >
        {(score && score?.review_count) ||
          intl.formatMessage(messages.noReviews)}
        <Stars stars={Number((score && score?.average_rating) || 0)} ml={1} />
        <Text pl={1}>{(score && score?.average_rating) || 0}</Text>
      </Flex>

      <Divider vertical mx={2.25} />

      <Flex
        as="a"
        href={`#reviews`}
        color="grey600"
        alignItems="center"
        onClick={(e) => {
          e.preventDefault();
          goToSection("questions");
          // posthog.capture("Clicked Product QnA");
        }}
      >
        <Icon icon={Question} color="inherit" fontSize={2} mr={1} />{" "}
        {score && score?.question_count > 0
          ? score.question_count
          : intl.formatMessage(messages.noQuestions)}{" "}
        <FormattedMessage {...messages.questions} />
      </Flex>
    </Flex>
  );
};
